import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import BBALoader from './BBALoader';
import { usePortalAccess } from '../hooks/usePortalAccess';
import { PORTAL_PAGE_MAPPING, PORTAL_PAGE_TOGGLE_KEYS } from '../services/portalAccessService';

// Routes the sidebar links to under a different path than their Access-tab mapping
const ROUTE_ALIASES = { '/portal/portal-calendar': '/portal/calendar' };

/** The PORTAL_PAGE_MAPPING route that owns this path (longest prefix), or null. */
export function mappedPortalRoute(pathname) {
  const path = ROUTE_ALIASES[pathname] || pathname.replace(/\/+$/, '');
  let best = null;
  for (const route of Object.keys(PORTAL_PAGE_MAPPING)) {
    if ((path === route || path.startsWith(`${route}/`)) && (!best || route.length > best.length)) best = route;
  }
  return best;
}

/**
 * Keeps a typed-in URL to the same pages the sidebar shows: a page whose Access-tab
 * toggle is off for the client's account redirects to the dashboard. Locked and
 * pending-start portals are left to PortalLockGuard / PortalPendingStartGate, and pages
 * without an Access-tab toggle are always open. The data itself is protected by the
 * Firestore rules; this guards the plan's page list.
 */
const PortalAccessGuard = ({ children }) => {
  const { loading, isPortalLocked, isPendingStart, isPageAccessible } = usePortalAccess();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <BBALoader size={40} />
      </div>
    );
  }
  if (isPortalLocked || isPendingStart) return <>{children}</>;

  const route = mappedPortalRoute(location.pathname);
  if (route && PORTAL_PAGE_TOGGLE_KEYS.includes(PORTAL_PAGE_MAPPING[route]) && !isPageAccessible(route)) {
    return <Navigate to="/portal" replace />;
  }
  return <>{children}</>;
};

export default PortalAccessGuard;
